export default __webpack_public_path__ + "static/media/feature3.cd73ecdb.png";